type Props = {
  height?: string | number;
  width?: string | number;
  onClick?: () => void;
};

export const SpeakerMutedIcon = ({ height, width, onClick }: Props) => {
  const color = '#00d091';

  return (
    <svg
      onClick={onClick}
      width={width || '27'}
      height={height || '25'}
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.2323 25L19.4129 21.1806C18.8868 21.5173 18.3291 21.8066 17.7399 22.0486C17.1507 22.2906 16.5404 22.4853 15.9091 22.6326V20.0442C16.2037 19.939 16.4931 19.8338 16.7771 19.7285C17.0612 19.6233 17.3295 19.4971 17.5821 19.3497L13.3838 15.1515V21.7172L7.07071 15.404H2.0202V7.82828H6.06061L0 1.76768L1.76768 0L25 23.2323L23.2323 25ZM22.9798 17.6768L21.149 15.846C21.5067 15.1936 21.775 14.5097 21.9539 13.7942C22.1328 13.0787 22.2222 12.3422 22.2222 11.5846C22.2222 9.60648 21.6435 7.8388 20.4861 6.28157C19.3287 4.72433 17.803 3.67214 15.9091 3.125V0.536616C18.5185 1.12584 20.6439 2.44634 22.2854 4.49811C23.9268 6.54987 24.7475 8.91204 24.7475 11.5846C24.7475 12.6999 24.5949 13.7731 24.2898 14.8043C23.9846 15.8354 23.548 16.7929 22.9798 17.6768ZM18.75 13.447L15.9091 10.6061V6.50252C16.8981 6.96549 17.6715 7.65993 18.2292 8.58586C18.7868 9.51178 19.0657 10.5219 19.0657 11.6162C19.0657 11.9318 19.0394 12.2422 18.9867 12.5473C18.9341 12.8525 18.8552 13.1524 18.75 13.447ZM13.3838 8.08081L10.101 4.79798L13.3838 1.51515V8.08081ZM10.8586 15.5934V12.6263L8.58586 10.3535H4.54545V12.8788H8.14394L10.8586 15.5934Z"
        fill={color}
      />
    </svg>
  );
};
